import { Button, Input, Modal } from 'antd';
import React, { useState } from 'react'
import { FaEdit, FaPlus, FaTrashAlt } from 'react-icons/fa';
import ImageVideoUploaderCategory from './ImageVideoUploaderCategory';

function CategoryImageUploader({images, setImages,bidID}) {

    // const initail = {

    //     "Full Front View": [],
    //     "Odometer Reading": [],
    //     "Front Left Angle": [],
    //     "Front Right Angle": [],
    //     "Rear View": []

    // }

    // const [images, setImages] = useState(initail);
    // const [bidID, setBidID] = useState();


    const [newKey, setNewKey] = useState(''); // For adding a new key
    const [oldKey, setOldKey] = useState(''); // For editing an existing key
    const [newKeyName, setNewKeyName] = useState(''); // New name for the edited key
    const [isAddModalOpen, setIsAddModalOpen] = useState(false); // Toggle add modal
    const [isEditModalOpen, setIsEditModalOpen] = useState(false); // Toggle edit modal


    // Utility function to capitalize first letter of each word
    const capitalizeWords = (str) => {
        return str.replace(/\b\w/g, (char) => char.toUpperCase());
    };

    // Function to add a new key
    const addKey = () => {
        if (newKey) {
            const formattedKey = capitalizeWords(newKey.trim());
            setImages(prevImages => ({
                ...prevImages,
                [formattedKey]: []
            }));
            setNewKey(''); // Clear the input field after adding
            setIsAddModalOpen(false); // Close the modal after adding
        }
    };

    // Function to edit an existing key (change its name)
    const editKey = () => {
        if (oldKey && newKeyName && images[oldKey]) {
            const formattedNewKey = capitalizeWords(newKeyName.trim());
            setImages(prevImages => {
                const { [oldKey]: value, ...rest } = prevImages;
                return {
                    ...rest,
                    [formattedNewKey]: value
                };
            });
            setOldKey(''); // Clear the input fields after editing
            setNewKeyName('');
            setIsEditModalOpen(false); // Close the modal after editing
        }
    };

    // Function to remove a key
    const removeKey = (key) => {
        setImages(prevImages => {
            const { [key]: _, ...rest } = prevImages;
            return rest;
        });
    };

    // Function to set the old key for editing
    const selectKeyForEdit = (key) => {
        setOldKey(key);
        setNewKeyName(''); // Clear the new key name input for a fresh edit
        setIsEditModalOpen(true); // Open the modal for editing
    };



    return (
        <div>
            {/* <div className="p-4 max-w-lg mx-auto bg-white shadow-md rounded-md">
                <h2 className="text-2xl font-bold mb-4">Image Manager</h2>

                <div className="mb-4">
                    <h4 className="text-lg font-semibold">Add Key</h4>
                    <input
                        type="text"
                        className="border border-gray-300 p-2 rounded-md w-full mb-2"
                        placeholder="New Key"
                        value={newKey}
                        onChange={(e) => setNewKey(e.target.value)}
                    />
                    <button
                        onClick={addKey}
                        className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
                    >
                        Add Key
                    </button>
                </div>

                <div className="mb-4">
                    <h4 className="text-lg font-semibold">Edit Key</h4>
                    <input
                        type="text"
                        className="border border-gray-300 p-2 rounded-md w-full mb-2"
                        placeholder="Current Key"
                        value={oldKey}
                        readOnly
                    />
                    <input
                        type="text"
                        className="border border-gray-300 p-2 rounded-md w-full mb-2"
                        placeholder="New Key Name"
                        value={newKeyName}
                        onChange={(e) => setNewKeyName(e.target.value)}
                    />
                    <button
                        onClick={editKey}
                        className="bg-green-500 text-white py-2 px-4 rounded-md hover:bg-green-600"
                    >
                        Edit Key
                    </button>
                </div>

                <div>
                    <h4 className="text-lg font-semibold mb-2">Current Keys</h4>
                    <div className="space-y-2">
                        {Object.keys(images).map((key) => (
                            <div key={key} className="flex justify-between items-center p-2 bg-gray-100 rounded-md">
                                <span className="text-gray-700 font-medium">{key}</span>
                                <div className="space-x-2">
                                    <button
                                        onClick={() => selectKeyForEdit(key)}
                                        className="text-blue-500 hover:text-blue-700"
                                        title="Edit"
                                    >
                                        <FaEdit />
                                    </button>
                                    <button
                                        onClick={() => removeKey(key)}
                                        className="text-red-500 hover:text-red-700"
                                        title="Delete"
                                    >
                                        <FaTrashAlt />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <pre className="mt-4 p-4 bg-gray-200 rounded-md">{JSON.stringify(images, null, 2)}</pre>
            </div> */}

            <div className="p-4 max-w-lg mx-auto bg-white shadow-md rounded-md">
                <h2 className="text-2xl font-bold mb-4">Gallery Image Manager</h2>
                <Button
                    onClick={() => setIsAddModalOpen(true)}
                    type="primary"
                    className="mt-4 flex items-center"
                    icon={<FaPlus />}
                >
                    Add Key
                </Button>

                {/* List of Keys with Add, Edit, and Remove Buttons */}
                <div className="mb-4 mt-2">
                    <div className="space-y-2">
                        {Object.keys(images).map((key) => (
                            <div key={key} className="  p-2 bg-gray-100 rounded-md">
                                <div className='flex justify-between items-center p-2'>

                                    <span className="text-gray-700 font-medium">{key}</span>
                                    <div className="space-x-2">
                                        <Button
                                            icon={<FaEdit />}
                                            onClick={() => selectKeyForEdit(key)}
                                            type="primary"
                                        >
                                            Edit
                                        </Button>
                                        <Button
                                            icon={<FaTrashAlt />}
                                            onClick={() => removeKey(key)}
                                            type="danger"
                                        >
                                            Delete
                                        </Button>
                                    </div>
                                </div>
                                <ImageVideoUploaderCategory images={images} setImages={setImages} productID={bidID} identifier={key} />

                            </div>
                        ))}
                    </div>

                </div>

                {/* Add Key Modal */}
                <Modal
                    title="Add Key"
                    visible={isAddModalOpen}
                    onOk={addKey}
                    onCancel={() => setIsAddModalOpen(false)}
                    okText="Add"
                    cancelText="Cancel"
                >
                    <Input
                        placeholder="New Key"
                        value={newKey}
                        onChange={(e) => setNewKey(e.target.value)}
                    />
                </Modal>

                {/* Edit Key Modal */}
                <Modal
                    title="Edit Key"
                    visible={isEditModalOpen}
                    onOk={editKey}
                    onCancel={() => setIsEditModalOpen(false)}
                    okText="Edit"
                    cancelText="Cancel"
                >
                    <Input
                        placeholder="Current Key"
                        value={oldKey}
                        readOnly
                    />
                    <Input
                        placeholder="New Key Name"
                        value={newKeyName}
                        onChange={(e) => setNewKeyName(e.target.value)}
                    />
                </Modal>

                {/* Display the Current State of Images */}
                {/* <pre className="mt-4 p-4 bg-gray-200 rounded-md">{JSON.stringify(images, null, 2)}</pre> */}
            </div>
        </div>
    )
}

export default CategoryImageUploader